import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ArrowIcon,
  Box,
  Button,
  CheckIcon,
  DestructiveIcon,
  Flex,
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Text,
  TextLink,
} from '@modusign/design-system';

export type FileSelectError = Array<'extension' | 'fileSize' | 'fileNotSelected' | 'fileOpenError'>;

interface ImageUploadErrorModalProps {
  errors: FileSelectError;
  isOpen: boolean;
  onConfirm: () => void;
}

function ImageUploadErrorModal({ errors, isOpen, onConfirm }: ImageUploadErrorModalProps) {
  if (!isOpen) {
    return null;
  }

  if (errors.includes('fileOpenError')) {
    return (
      <Modal isOpen={isOpen} maxWidth="xs" onClose={onConfirm}>
        <ModalTitle icon={<DestructiveIcon color="iconPrimaryBase" />}>
          이미지 업로드 안내
        </ModalTitle>
        <ModalContent>
          <Text as="p" mb={6} textAlign="center">
            이미지 파일을 열 수 없습니다.
          </Text>
        </ModalContent>
        <ModalFooter>
          <Button onClick={onConfirm}>확인</Button>
        </ModalFooter>
      </Modal>
    );
  }

  if (errors.includes('fileNotSelected')) {
    return (
      <Modal isOpen={isOpen} maxWidth="xs" onClose={onConfirm}>
        <ModalTitle icon={<DestructiveIcon color="iconPrimaryBase" />}>
          이미지 업로드 안내
        </ModalTitle>
        <ModalContent>
          <Text as="p" mb={6} textAlign="center">
            파일이 선택되지 않았습니다.
          </Text>
        </ModalContent>
        <ModalFooter>
          <Button onClick={onConfirm}>확인</Button>
        </ModalFooter>
      </Modal>
    );
  }

  return (
    <Modal isOpen={isOpen} maxWidth="xs" onClose={onConfirm}>
      <ModalTitle icon={<DestructiveIcon color="iconPrimaryBase" />}>이미지 업로드 안내</ModalTitle>
      <ModalContent textAlign="center">
        <Text as="p" mb={6} textAlign="center">
          아래 업로드 조건을 확인 후 업로드해 주세요.
        </Text>
        <Box
          bg="boxBackgroundNeutralBase"
          borderColor="boxBorderNeutralBase"
          borderStyle="solid"
          borderWidth="1px"
          mb={6}
          px={6}
          py={7}
        >
          <Flex
            alignItems="center"
            color={errors.includes('extension') ? 'iconNegativeBase' : 'textNeutralBase'}
            mb={2}
          >
            {errors.includes('extension') ? (
              <FontAwesomeIcon icon={faXmark} style={{ width: '14px' }} />
            ) : (
              <CheckIcon height="12" variant="filled" width="12" />
            )}
            <Text ml={1}>JPG 또는 PNG 파일</Text>
          </Flex>
          <Flex
            alignItems="center"
            color={errors.includes('fileSize') ? 'iconNegativeBase' : 'textNeutralBase'}
          >
            {errors.includes('fileSize') ? (
              <FontAwesomeIcon icon={faXmark} style={{ width: '14px' }} />
            ) : (
              <CheckIcon height="12" variant="filled" width="12" />
            )}
            <Text ml={1}>파일 크기 최대 3MB</Text>
          </Flex>
        </Box>
        <TextLink
          href="https://support.modusign.co.kr/hc/ko/articles/360022334274"
          rel="noopener noreferrer"
          target="_blank"
        >
          이미지 업로드 도움말
          <ArrowIcon direction="right" ml={2} />
        </TextLink>
      </ModalContent>
      <ModalFooter>
        <Button onClick={onConfirm}>확인</Button>
      </ModalFooter>
    </Modal>
  );
}

export default ImageUploadErrorModal;
